module.exports = __webpack_public_path__ + "img/hero_portrait_monk_male.84f7e3bc.png";